module.exports = __webpack_public_path__ + "img/Logo Exxon Mobile.6f057aec.jpg";